import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'hostedblog/preview/post';

/**
 * Server-renders a draft blog post through the same pipeline that serves the live
 * hosted blog page (real theme + chrome) and returns the full page HTML.
 */
export function useHostedBlogPostPreviewQuery({
	title,
	content,
	mainImage,
	author,
	impersonationContext,
	enabled = true,
}: {
	title: string;
	content?: Api.IRawRichTextContentState;
	mainImage?: Api.IFileAttachmentWithURL | null;
	author?: string;
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		meta: {
			toastErrorMessage: 'Failed to load the blog post preview',
		},
		queryFn: () =>
			new Promise<string>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						impersonationContext,
						urlPath: 'hostedblog/preview/post',
					}),
					'POST',
					{ author, content, mainImage, title },
					async response => {
						resolve(await response.text());
					},
					error => {
						reject(error);
					}
				);
			}),
		queryKey: [BASE_QUERY_KEY, impersonationContext, title, content, mainImage, author],
	});
}
